import { useState } from 'react';
import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';
import { categories, slugToCategory } from '@/mocks/categories';
import MovieCard from '@/pages/home/components/MovieCard';

export default function LatestSection() {
  const [activeTab, setActiveTab] = useState('全部');
  const allTabs = ['全部', ...categories.map((c) => c.name)];

  const filteredMovies =
    activeTab === '全部'
      ? movies
      : movies.filter((m) => m.category === activeTab);

  const activeCategorySlug =
    activeTab === '全部' ? null : categories.find((c) => c.name === activeTab)?.slug;

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
            最新上线
          </h2>
          <p className="text-sm text-foreground-600">实时更新热门影视资源，追剧观影快人一步</p>
        </div>

        <div className="flex items-center justify-center mb-8">
          <div className="inline-flex items-center bg-background-100 rounded-full p-1 gap-1 overflow-x-auto flex-nowrap">
            {allTabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === tab
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {filteredMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        {activeCategorySlug && (
          <div className="mt-8 text-center">
            <Link
              to={`/category/${activeCategorySlug}`}
              className="inline-flex items-center gap-1.5 px-6 py-3 rounded-full border border-primary-400 text-primary-500 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
            >
              <span>查看全部{activeTab}</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}